import VueI18n from "vue-i18n";
import Vue from "vue";

import en from "@/lang/en.json";
import th from "@/lang/th.json";

Vue.use(VueI18n);
const locale = "th";
const messages = {
  en,
  th
};
const i18n = new VueI18n({
  locale,
  messages
});
export default i18n;
